@if (alerts().length) {
  <section class="nv-kra" role="alert" aria-label="Items ready from the kitchen" data-testid="ready-alerts">
    <h2 class="nv-kra__title">
      <nv-icon [size]="22" filled>room_service</nv-icon>
      Ready from the kitchen
      @if (alerts().length > 1) {
        <span class="nv-kra__count">{{ alerts().length }}</span>
      }
    </h2>
    <ul class="nv-kra__list">
      @for (alert of alerts(); track alert.key) {
        <li class="nv-kra__item" data-testid="ready-alert" [attr.data-line-id]="alert.lineId">
          @if (alert.imageUrl) {
            <img class="nv-kra__img" [src]="alert.imageUrl" alt="" />
          } @else {
            <span class="nv-kra__img nv-kra__img--empty" aria-hidden="true"><nv-icon [size]="24">restaurant</nv-icon></span>
          }
          <div class="nv-kra__body">
            <p class="nv-kra__name">
              {{ alert.name }}
              @if (alert.quantity > 1) {
                <span>× {{ alert.quantity }}</span>
              }
            </p>
            <p class="nv-kra__meta">
              Table {{ tableLabel(alert.tableId) }}
              @if (alert.kotNo) {
                · KOT {{ alert.kotNo }}
              }
              @if (alert.readyByName) {
                · {{ alert.readyByName }}
              }
            </p>
          </div>
          <button type="button" nvButton="primary" data-testid="ready-alert-ack" (click)="acknowledge(alert)">Got it</button>
        </li>
      }
    </ul>
  </section>
}
